import React from 'react';

import PropTypes from 'prop-types';

import { MarkedListItemContainer } from './styles';
import { LightIcon } from '../LightIcon/LightIcon';
import { LightText } from '../LightText/LightText';

export const LightMarkedListItem = (props) => {
    return (
        <MarkedListItemContainer>
            <LightIcon name="check" color="purple" rightIndent="24px" size={'24px'} />
            <LightText>{props.text}</LightText>
        </MarkedListItemContainer>
    );
};

LightMarkedListItem.propTypes = {
    text: PropTypes.string,
};
